// FIXME: Yoshi 6 stopped supporting names exports on December 2023 (bug in a Babbel version or something like that),
// so I had to refactor all these to separate import / export lines.
// Maybe one day, you, the future maintainer, will be able to use named exports again.
import type { FadeIn } from '../effects/fadeIn';
import * as _fadeIn from '../effects/fadeIn';

import type { SpinIn } from '../effects/spinIn';
import * as _spinIn from '../effects/spinIn';

import type { ArcIn } from '../effects/arcIn';
import * as _arcIn from '../effects/arcIn';

import type { DropIn } from '../effects/dropIn';
import * as _dropIn from '../effects/dropIn';

import type { ExpandIn } from '../effects/expandIn';
import * as _expandIn from '../effects/expandIn';

import type { FlipIn } from '../effects/flipIn';
import * as _flipIn from '../effects/flipIn';

import type { FloatIn } from '../effects/floatIn';
import * as _floatIn from '../effects/floatIn';

import type { FoldIn } from '../effects/foldIn';
import * as _foldIn from '../effects/foldIn';

import type { SlideIn } from '../effects/slideIn';
import * as _slideIn from '../effects/slideIn';

import type { BounceIn } from '../effects/bounceIn';
import * as _bounceIn from '../effects/bounceIn';

import type { TurnIn } from '../effects/turnIn';
import * as _turnIn from '../effects/turnIn';

import type { RevealIn } from '../effects/revealIn';
import * as _revealIn from '../effects/revealIn';

import type { WinkIn } from '../effects/winkIn';
import * as _winkIn from '../effects/winkIn';

import type { TiltIn } from '../effects/tiltIn';
import * as _tiltIn from '../effects/tiltIn';

import type { ShapeIn } from '../effects/shapeIn';
import * as _shapeIn from '../effects/shapeIn';

import type { ShuttersIn } from '../effects/shuttersIn';
import * as _shuttersIn from '../effects/shuttersIn';

import type { GrowIn } from '../effects/growIn';
import * as _growIn from '../effects/growIn';

import type { GlideIn } from '../effects/glideIn';
import * as _glideIn from '../effects/glideIn';

import type { GlitchIn } from '../effects/glitchIn';
import * as _glitchIn from '../effects/glitchIn';

import type { CircleIn } from '../effects/circleIn';
import * as _circleIn from '../effects/circleIn';

import type { CurveIn } from '../effects/curveIn';
import * as _curveIn from '../effects/curveIn';

import type { FlyIn } from '../effects/flyIn';
import * as _flyIn from '../effects/flyIn';

import type { PunchIn } from '../effects/punchIn';
import * as _punchIn from '../effects/punchIn';

import type { BlurIn } from '../effects/blurIn';
import * as _blurIn from '../effects/blurIn';

import type { Bounce } from '../effects/bounce';
import * as _Bounce from '../effects/bounce';

import type { Breathe } from '../effects/breathe';
import * as _Breathe from '../effects/breathe';

import type { Flash } from '../effects/flash';
import * as _Flash from '../effects/flash';

import type { Flip } from '../effects/flip';
import * as _Flip from '../effects/flip';

import type { Fold } from '../effects/fold';
import * as _Fold from '../effects/fold';

import type { Jello } from '../effects/jello';
import * as _Jello from '../effects/jello';

import type { Poke } from '../effects/poke';
import * as _Poke from '../effects/poke';

import type { Pulse } from '../effects/pulse';
import * as _Pulse from '../effects/pulse';

import type { Rubber } from '../effects/rubber';
import * as _Rubber from '../effects/rubber';

import type { Wiggle } from '../effects/wiggle';
import * as _Wiggle from '../effects/wiggle';

import type { Spin } from '../effects/spin';
import * as _Spin from '../effects/spin';

import type { Swing } from '../effects/swing';
import * as _Swing from '../effects/swing';

import type { Cross } from '../effects/cross';
import * as _Cross from '../effects/cross';

import type { DVD } from '../effects/dvd';
import * as _DVD from '../effects/dvd';

import type { GrowScroll } from '../effects/growScroll';
import * as _GrowScroll from '../effects/growScroll';

import type { ShrinkScroll } from '../effects/shrinkScroll';
import * as _ShrinkScroll from '../effects/shrinkScroll';

import type { FlipScroll } from '../effects/flipScroll';
import * as _FlipScroll from '../effects/flipScroll';

import type { SpinScroll } from '../effects/spinScroll';
import * as _SpinScroll from '../effects/spinScroll';

import type { Spin3dScroll } from '../effects/spin3dScroll';
import * as _Spin3dScroll from '../effects/spin3dScroll';

import type { ShuttersScroll } from '../effects/shuttersScroll';
import * as _ShuttersScroll from '../effects/shuttersScroll';

import type { FadeScroll } from '../effects/fadeScroll';
import * as _FadeScroll from '../effects/fadeScroll';

import type { MoveScroll } from '../effects/moveScroll';
import * as _MoveScroll from '../effects/moveScroll';

import type { ParallaxScroll } from '../effects/parallaxScroll';
import * as _ParallaxScroll from '../effects/parallaxScroll';

import type { StretchScroll } from '../effects/stretchScroll';
import * as _StretchScroll from '../effects/stretchScroll';

import type { ShapeScroll } from '../effects/shapeScroll';
import * as _ShapeScroll from '../effects/shapeScroll';

import type { BlurScroll } from '../effects/blurScroll';
import * as _BlurScroll from '../effects/blurScroll';

import type { TurnScroll } from '../effects/turnScroll';
import * as _TurnScroll from '../effects/turnScroll';

import type { SkewPanScroll } from '../effects/skewPanScroll';
import * as _SkewPanScroll from '../effects/skewPanScroll';

import type { SlideScroll } from '../effects/slideScroll';
import * as _SlideScroll from '../effects/slideScroll';

import type { PanScroll } from '../effects/panScroll';
import * as _PanScroll from '../effects/panScroll';

import type { ArcScroll } from '../effects/arcScroll';
import * as _ArcScroll from '../effects/arcScroll';

import type { TiltScroll } from '../effects/tiltScroll';
import * as _TiltScroll from '../effects/tiltScroll';

import type { RevealScroll } from '../effects/revealScroll';
import * as _RevealScroll from '../effects/revealScroll';

import type { Tilt3DMouse } from '../effects/mouse/tilt3DMouse';
import * as _Tilt3DMouse from '../effects/mouse/tilt3DMouse';

import type { SpinMouse } from '../effects/mouse/spinMouse';
import * as _SpinMouse from '../effects/mouse/spinMouse';

import type { SwivelMouse } from '../effects/mouse/swivelMouse';
import * as _SwivelMouse from '../effects/mouse/swivelMouse';

import type { TrackMouse } from '../effects/mouse/trackMouse';
import * as _TrackMouse from '../effects/mouse/trackMouse';

import type { BlobMouse } from '../effects/mouse/blobMouse';
import * as _BlobMouse from '../effects/mouse/blobMouse';

import type { BlurMouse } from '../effects/mouse/blurMouse';
import * as _BlurMouse from '../effects/mouse/blurMouse';

import type { SkewMouse } from '../effects/mouse/skewMouse';
import * as _SkewMouse from '../effects/mouse/skewMouse';

import type { ScaleMouse } from '../effects/mouse/scaleMouse';
import * as _ScaleMouse from '../effects/mouse/scaleMouse';

import type { AiryMouse } from '../effects/mouse/airyMouse';
import * as _AiryMouse from '../effects/mouse/airyMouse';

import type { Track3DMouse } from '../effects/mouse/track3DMouse';
import * as _Track3DMouse from '../effects/mouse/track3DMouse';

import type { BounceMouse } from '../effects/mouse/bounceMouse';
import * as _BounceMouse from '../effects/mouse/bounceMouse';

export {
  _fadeIn as fadeIn,
  _spinIn as spinIn,
  _arcIn as arcIn,
  _dropIn as dropIn,
  _expandIn as expandIn,
  _flipIn as flipIn,
  _floatIn as floatIn,
  _foldIn as foldIn,
  _slideIn as slideIn,
  _bounceIn as bounceIn,
  _turnIn as turnIn,
  _revealIn as revealIn,
  _winkIn as winkIn,
  _tiltIn as tiltIn,
  _shapeIn as shapeIn,
  _shuttersIn as shuttersIn,
  _growIn as growIn,
  _glideIn as glideIn,
  _glitchIn as glitchIn,
  _circleIn as circleIn,
  _curveIn as curveIn,
  _flyIn as flyIn,
  _punchIn as punchIn,
  _blurIn as blurIn,
  _Bounce as Bounce,
  _Breathe as Breathe,
  _Flash as Flash,
  _Flip as Flip,
  _Fold as Fold,
  _Jello as Jello,
  _Poke as Poke,
  _Pulse as Pulse,
  _Rubber as Rubber,
  _Wiggle as Wiggle,
  _Spin as Spin,
  _Swing as Swing,
  _Cross as Cross,
  _DVD as DVD,
  _GrowScroll as GrowScroll,
  _ShrinkScroll as ShrinkScroll,
  _FlipScroll as FlipScroll,
  _SpinScroll as SpinScroll,
  _Spin3dScroll as Spin3dScroll,
  _ShuttersScroll as Shutter_ShuttersScroll,
  _FadeScroll as FadeScroll,
  _MoveScroll as MoveScroll,
  _ParallaxScroll as ParallaxScroll,
  _StretchScroll as StretchScroll,
  _ShapeScroll as ShapeScroll,
  _BlurScroll as BlurScroll,
  _TurnScroll as TurnScroll,
  _SkewPanScroll as SkewPanScroll,
  _SlideScroll as SlideScroll,
  _PanScroll as PanScroll,
  _ArcScroll as ArcScroll,
  _TiltScroll as TiltScroll,
  _RevealScroll as RevealScroll,
  _Tilt3DMouse as Tilt3DMouse,
  _SpinMouse as SpinMouse,
  _SwivelMouse as SwivelMouse,
  _TrackMouse as TrackMouse,
  _BlobMouse as BlobMouse,
  _BlurMouse as BlurMouse,
  _SkewMouse as SkewMouse,
  _ScaleMouse as ScaleMouse,
  _AiryMouse as AiryMouse,
  _Track3DMouse as Track3DMouse,
  _BounceMouse as BounceMouse,
};

export interface AllEntranceEffectParams {
  ArcIn: ArcIn;
  BounceIn: BounceIn;
  ShuttersIn: ShuttersIn;
  DropIn: DropIn;
  ExpandIn: ExpandIn;
  FadeIn: FadeIn;
  FlipIn: FlipIn;
  FloatIn: FloatIn;
  FoldIn: FoldIn;
  GlideIn: GlideIn;
  GlitchIn: GlitchIn;
  GrowIn: GrowIn;
  RevealIn: RevealIn;
  ShapeIn: ShapeIn;
  SlideIn: SlideIn;
  SpinIn: SpinIn;
  TiltIn: TiltIn;
  TurnIn: TurnIn;
  WinkIn: WinkIn;
  BlurIn: BlurIn;
  // Legacy
  CircleIn: CircleIn;
  CurveIn: CurveIn;
  FlyIn: FlyIn;
  PunchIn: PunchIn;
}

export interface AllOngoingEffectParams {
  Bounce: Bounce;
  Breathe: Breathe;
  Flash: Flash;
  Flip: Flip;
  Fold: Fold;
  Jello: Jello;
  Poke: Poke;
  Pulse: Pulse;
  Rubber: Rubber;
  Wiggle: Wiggle;
  Spin: Spin;
  Swing: Swing;
  Cross: Cross;
  DVD: DVD;
}
export interface AllScrollEffectParams {
  ArcScroll: ArcScroll;
  BlurScroll: BlurScroll;
  FadeScroll: FadeScroll;
  FlipScroll: FlipScroll;
  GrowScroll: GrowScroll;
  PanScroll: PanScroll;
  ParallaxScroll: ParallaxScroll;
  ShapeScroll: ShapeScroll;
  ShrinkScroll: ShrinkScroll;
  SpinScroll: SpinScroll;
  Spin3dScroll: Spin3dScroll;
  ShuttersScroll: ShuttersScroll;
  SkewPanScroll: SkewPanScroll;
  SlideScroll: SlideScroll;
  StretchScroll: StretchScroll;
  TiltScroll: TiltScroll;
  TurnScroll: TurnScroll;
  MoveScroll: MoveScroll;
  RevealScroll: RevealScroll;
}

export interface AllMouseEffectParams {
  Tilt3DMouse: Tilt3DMouse;
  SpinMouse: SpinMouse;
  SwivelMouse: SwivelMouse;
  TrackMouse: TrackMouse;
  BlobMouse: BlobMouse;
  BlurMouse: BlurMouse;
  SkewMouse: SkewMouse;
  ScaleMouse: ScaleMouse;
  AiryMouse: AiryMouse;
  Track3DMouse: Track3DMouse;
  BounceMouse: BounceMouse;
}

export type AllEffectParams = AllEntranceEffectParams &
  AllOngoingEffectParams &
  AllScrollEffectParams &
  AllMouseEffectParams;
